<template>
	<div v-if="playlist_url">
		<v-layout row>
			<v-flex xs12>
				<video-player v-if="playlist_url" ref="player" style="max-width: 960px; max-height: 540px;" :url="playlist_url" v-on:position-duration="position_duration"></video-player>
				<div v-if="!playlist_url">Cannot load video</div>
			</v-flex>
		</v-layout>

		<v-layout row>
			<v-flex xs12>

				<v-btn @click="take_clip(60)" small color="success"> Clip </v-btn>
					<v-menu offset-y :close-on-content-click="false" :nudge-width="150" v-model="tag_dialog">
					<v-btn small color="success" dark slot="activator">Add tag</v-btn>

					<v-card style="min-width: 350px; max-width: 350px; padding: 10px;" v-if="tag_dialog">        		
						<tag-editor :event_uuid="uuid" :position="position" v-on:save="tag_dialog=false"></tag-editor>
        	</v-card>
				</v-menu>
			</v-flex>
		</v-layout>


	</div>
</template>

<script>
import VideoPlayer from './VideoPlayerClappr.vue';
import TagEditor from '../events/tags/Editor.vue';

export default {
	props: ["uuid"],
	components: {
		VideoPlayer,
		TagEditor
	},
	data () {
		var config_ch = this.$cloudserver.channel("events:clip_settings:"+this.uuid);
		return {
			ws_channel: config_ch,
			playlist_url: undefined,
			position: undefined,
			duration: undefined,
			tag_dialog: false
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				this.playlist_url = newVal.live_playlist_url;
			},
			deep: true
		}
	},
	created () {
		this.ws_channel.join();
	},
	methods: {
		position_duration(value) {
			this.position = value.position;
			this.duration = value.duration;
		},
		take_clip(clip_length) {
			this.$emit("clip", {duration: this.duration, position: this.position, length: clip_length});
		}
	}

}
</script>